import { Box, Flex } from '@chakra-ui/react';
import { useTenantContext } from '@duke-hq/app-provider-web/tenant/TenantContext';
import { CausesManagement } from './CausesManagement';
import { SiteLeaderboard } from './Sites/SiteLeaderboard';
import { ContributorsLeaderboard } from './Contributors/ContributorsLeaderboard';

export function GroupRewardsAdmin() {
  const tenantCtx = useTenantContext();
  return (
    <Flex direction="column" gap={6}>
      <Flex direction={{ base: 'column', lg: 'row' }} gap={{ base: 6, lg: 12 }}>
        <Box
          flex={{ base: '1', lg: '2' }}
          minW={{ base: 'auto', lg: '0' }}
          overflowX={{ base: 'visible', lg: 'auto' }}
          borderRadius="md"
          border="1px"
          borderColor="gray.100"
        >
          <ContributorsLeaderboard />
        </Box>
        <Box
          flex={{ base: '1', lg: '1' }}
          maxW={{ base: 'none', lg: '400px' }}
          flexShrink={0}
          borderRadius="md"
          border="1px"
          borderColor="gray.100"
        >
          <SiteLeaderboard />
        </Box>
      </Flex>
      {tenantCtx?.permissions.includes('canManageCauses') === true ? (
        <Box borderRadius="md" border="1px" borderColor="gray.100">
          <CausesManagement />
        </Box>
      ) : null}
    </Flex>
  );
}
